const provideData = [
    {
        "text": "北京",
        "value": "110000",
        "children": [
            {
                "text": "北京",
                "value": "110101"
            }
        ]
    },
    {
        "text": "天津",
        "value": "120000",
        "children": [
            {
                "text": "天津",
                "value": "120101"
            }
        ]
    },
    {
        "text": "河北",
        "value": "130000",
        "children": [
            {
                "text": "石家庄",
                "value": "130100"
            },
            {
                "text": "唐山",
                "value": "130200"
            },
            {
                "text": "秦皇岛",
                "value": "130300"
            },
            {
                "text": "邯郸",
                "value": "130400"
            },
            {
                "text": "邢台",
                "value": "130500"
            },
            {
                "text": "保定",
                "value": "130600"
            },
            {
                "text": "张家口",
                "value": "130700"
            },
            {
                "text": "承德",
                "value": "130800"
            },
            {
                "text": "沧州",
                "value": "130900"
            },
            {
                "text": "廊坊",
                "value": "131000"
            },
            {
                "text": "衡水",
                "value": "131100"
            }
        ]
    },
    {
        "text": "山西",
        "value": "140000",
        "children": [
            {
                "text": "太原",
                "value": "140100"
            },
            {
                "text": "大同",
                "value": "140200"
            },
            {
                "text": "阳泉",
                "value": "140300"
            },
            {
                "text": "长治",
                "value": "140400"
            },
            {
                "text": "晋城",
                "value": "140500"
            },
            {
                "text": "朔州",
                "value": "140600"
            },
            {
                "text": "晋中",
                "value": "140700"
            },
            {
                "text": "运城",
                "value": "140800"
            },
            {
                "text": "忻州",
                "value": "140900"
            },
            {
                "text": "临汾",
                "value": "141000"
            },
            {
                "text": "吕梁",
                "value": "141100"
            }
        ]
    },
    {
        "text": "内蒙古自治区",
        "value": "150000",
        "children": [
            {
                "text": "呼和浩特",
                "value": "150100"
            },
            {
                "text": "包头",
                "value": "150200"
            },
            {
                "text": "乌海",
                "value": "150300"
            },
            {
                "text": "赤峰",
                "value": "150400"
            },
            {
                "text": "通辽",
                "value": "150500"
            },
            {
                "text": "鄂尔多斯",
                "value": "150600"
            },
            {
                "text": "呼伦贝尔",
                "value": "150700"
            },
            {
                "text": "巴彦淖尔",
                "value": "150800"
            },
            {
                "text": "乌兰察布",
                "value": "150900"
            },
            {
                "text": "兴安盟",
                "value": "152200"
            },
            {
                "text": "锡林郭勒盟",
                "value": "152500"
            },
            {
                "text": "阿拉善盟",
                "value": "152900"
            }
        ]
    },
    {
        "text": "辽宁",
        "value": "210000",
        "children": [
            {
                "text": "沈阳",
                "value": "210100"
            },
            {
                "text": "大连",
                "value": "210200"
            },
            {
                "text": "鞍山",
                "value": "210300"
            },
            {
                "text": "抚顺",
                "value": "210400"
            },
            {
                "text": "本溪",
                "value": "210500"
            },
            {
                "text": "丹东",
                "value": "210600"
            },
            {
                "text": "锦州",
                "value": "210700"
            },
            {
                "text": "营口",
                "value": "210800"
            },
            {
                "text": "阜新",
                "value": "210900"
            },
            {
                "text": "辽阳",
                "value": "211000"
            },
            {
                "text": "盘锦",
                "value": "211100"
            },
            {
                "text": "铁岭",
                "value": "211200"
            },
            {
                "text": "朝阳",
                "value": "211300"
            },
            {
                "text": "葫芦岛",
                "value": "211400"
            }
        ]
    },
    {
        "text": "吉林",
        "value": "220000",
        "children": [
            {
                "text": "长春",
                "value": "220100"
            },
            {
                "text": "吉林",
                "value": "220200"
            },
            {
                "text": "四平",
                "value": "220300"
            },
            {
                "text": "辽源",
                "value": "220400"
            },
            {
                "text": "通化",
                "value": "220500"
            },
            {
                "text": "白山",
                "value": "220600"
            },
            {
                "text": "松原",
                "value": "220700"
            },
            {
                "text": "白城",
                "value": "220800"
            },
            {
                "text": "延边朝鲜族自治州",
                "value": "222400"
            }
        ]
    },
    {
        "text": "黑龙江",
        "value": "230000",
        "children": [
            {
                "text": "哈尔滨",
                "value": "230100"
            },
            {
                "text": "齐齐哈尔",
                "value": "230200"
            },
            {
                "text": "鸡西",
                "value": "230300"
            },
            {
                "text": "鹤岗",
                "value": "230400"
            },
            {
                "text": "双鸭山",
                "value": "230500"
            },
            {
                "text": "大庆",
                "value": "230600"
            },
            {
                "text": "伊春",
                "value": "230700"
            },
            {
                "text": "佳木斯",
                "value": "230800"
            },
            {
                "text": "七台河",
                "value": "230900"
            },
            {
                "text": "牡丹江",
                "value": "231000"
            },
            {
                "text": "黑河",
                "value": "231100"
            },
            {
                "text": "绥化",
                "value": "231200"
            },
            {
                "text": "大兴安岭地区",
                "value": "232700"
            }
        ]
    },
    {
        "text": "上海",
        "value": "310000",
        "children": [
            {
                "text": "上海",
                "value": "310101"
            }
        ]
    },
    {
        "text": "江苏",
        "value": "320000",
        "children": [
            {
                "text": "南京",
                "value": "320100"
            },
            {
                "text": "无锡",
                "value": "320200"
            },
            {
                "text": "徐州",
                "value": "320300"
            },
            {
                "text": "常州",
                "value": "320400"
            },
            {
                "text": "苏州",
                "value": "320500"
            },
            {
                "text": "南通",
                "value": "320600"
            },
            {
                "text": "连云港",
                "value": "320700"
            },
            {
                "text": "淮安",
                "value": "320800"
            },
            {
                "text": "盐城",
                "value": "320900"
            },
            {
                "text": "扬州",
                "value": "321000"
            },
            {
                "text": "镇江",
                "value": "321100"
            },
            {
                "text": "泰州",
                "value": "321200"
            },
            {
                "text": "宿迁",
                "value": "321300"
            }
        ]
    },
    {
        "text": "浙江",
        "value": "330000",
        "children": [
            {
                "text": "杭州",
                "value": "330100"
            },
            {
                "text": "宁波",
                "value": "330200"
            },
            {
                "text": "温州",
                "value": "330300"
            },
            {
                "text": "嘉兴",
                "value": "330400"
            },
            {
                "text": "湖州",
                "value": "330500"
            },
            {
                "text": "绍兴",
                "value": "330600"
            },
            {
                "text": "金华",
                "value": "330700"
            },
            {
                "text": "衢州",
                "value": "330800"
            },
            {
                "text": "舟山",
                "value": "330900"
            },
            {
                "text": "台州",
                "value": "331000"
            },
            {
                "text": "丽水",
                "value": "331100"
            }
        ]
    },
    {
        "text": "安徽",
        "value": "340000",
        "children": [
            {
                "text": "合肥",
                "value": "340100"
            },
            {
                "text": "芜湖",
                "value": "340200"
            },
            {
                "text": "蚌埠",
                "value": "340300"
            },
            {
                "text": "淮南",
                "value": "340400"
            },
            {
                "text": "马鞍山",
                "value": "340500"
            },
            {
                "text": "淮北",
                "value": "340600"
            },
            {
                "text": "铜陵",
                "value": "340700"
            },
            {
                "text": "安庆",
                "value": "340800"
            },
            {
                "text": "黄山",
                "value": "341000"
            },
            {
                "text": "滁州",
                "value": "341100"
            },
            {
                "text": "阜阳",
                "value": "341200"
            },
            {
                "text": "宿州",
                "value": "341300"
            },
            {
                "text": "六安",
                "value": "341500"
            },
            {
                "text": "亳州",
                "value": "341600"
            },
            {
                "text": "池州",
                "value": "341700"
            },
            {
                "text": "宣城",
                "value": "341800"
            }
        ]
    },
    {
        "text": "福建",
        "value": "350000",
        "children": [
            {
                "text": "福州",
                "value": "350100"
            },
            {
                "text": "厦门",
                "value": "350200"
            },
            {
                "text": "莆田",
                "value": "350300"
            },
            {
                "text": "三明",
                "value": "350400"
            },
            {
                "text": "泉州",
                "value": "350500"
            },
            {
                "text": "漳州",
                "value": "350600"
            },
            {
                "text": "南平",
                "value": "350700"
            },
            {
                "text": "龙岩",
                "value": "350800"
            },
            {
                "text": "宁德",
                "value": "350900"
            }
        ]
    },
    {
        "text": "江西",
        "value": "360000",
        "children": [
            {
                "text": "南昌",
                "value": "360100"
            },
            {
                "text": "景德镇",
                "value": "360200"
            },
            {
                "text": "萍乡",
                "value": "360300"
            },
            {
                "text": "九江",
                "value": "360400"
            },
            {
                "text": "新余",
                "value": "360500"
            },
            {
                "text": "鹰潭",
                "value": "360600"
            },
            {
                "text": "赣州",
                "value": "360700"
            },
            {
                "text": "吉安",
                "value": "360800"
            },
            {
                "text": "宜春",
                "value": "360900"
            },
            {
                "text": "抚州",
                "value": "361000"
            },
            {
                "text": "上饶",
                "value": "361100"
            }
        ]
    },
    {
        "text": "山东",
        "value": "370000",
        "children": [
            {
                "text": "济南",
                "value": "370100"
            },
            {
                "text": "青岛",
                "value": "370200"
            },
            {
                "text": "淄博",
                "value": "370300"
            },
            {
                "text": "枣庄",
                "value": "370400"
            },
            {
                "text": "东营",
                "value": "370500"
            },
            {
                "text": "烟台",
                "value": "370600"
            },
            {
                "text": "潍坊",
                "value": "370700"
            },
            {
                "text": "济宁",
                "value": "370800"
            },
            {
                "text": "泰安",
                "value": "370900"
            },
            {
                "text": "威海",
                "value": "371000"
            },
            {
                "text": "日照",
                "value": "371100"
            },
            {
                "text": "临沂",
                "value": "371300"
            },
            {
                "text": "德州",
                "value": "371400"
            },
            {
                "text": "聊城",
                "value": "371500"
            },
            {
                "text": "滨州",
                "value": "371600"
            },
            {
                "text": "菏泽",
                "value": "371700"
            }
        ]
    },
    {
        "text": "河南",
        "value": "410000",
        "children": [
            {
                "text": "郑州",
                "value": "410100"
            },
            {
                "text": "开封",
                "value": "410200"
            },
            {
                "text": "洛阳",
                "value": "410300"
            },
            {
                "text": "平顶山",
                "value": "410400"
            },
            {
                "text": "安阳",
                "value": "410500"
            },
            {
                "text": "鹤壁",
                "value": "410600"
            },
            {
                "text": "新乡",
                "value": "410700"
            },
            {
                "text": "焦作",
                "value": "410800"
            },
            {
                "text": "濮阳",
                "value": "410900"
            },
            {
                "text": "许昌",
                "value": "411000"
            },
            {
                "text": "漯河",
                "value": "411100"
            },
            {
                "text": "三门峡",
                "value": "411200"
            },
            {
                "text": "南阳",
                "value": "411300"
            },
            {
                "text": "商丘",
                "value": "411400"
            },
            {
                "text": "信阳",
                "value": "411500"
            },
            {
                "text": "周口",
                "value": "411600"
            },
            {
                "text": "驻马店",
                "value": "411700"
            }
        ]
    },
    {
        "text": "湖北",
        "value": "420000",
        "children": [
            {
                "text": "武汉",
                "value": "420100"
            },
            {
                "text": "黄石",
                "value": "420200"
            },
            {
                "text": "十堰",
                "value": "420300"
            },
            {
                "text": "宜昌",
                "value": "420500"
            },
            {
                "text": "襄阳",
                "value": "420600"
            },
            {
                "text": "鄂州",
                "value": "420700"
            },
            {
                "text": "荆门",
                "value": "420800"
            },
            {
                "text": "孝感",
                "value": "420900"
            },
            {
                "text": "荆州",
                "value": "421000"
            },
            {
                "text": "黄冈",
                "value": "421100"
            },
            {
                "text": "咸宁",
                "value": "421200"
            },
            {
                "text": "随州",
                "value": "421300"
            },
            {
                "text": "恩施土家族苗族自治州",
                "value": "422800"
            }
        ]
    },
    {
        "text": "湖南",
        "value": "430000",
        "children": [
            {
                "text": "长沙",
                "value": "430100"
            },
            {
                "text": "株洲",
                "value": "430200"
            },
            {
                "text": "湘潭",
                "value": "430300"
            },
            {
                "text": "衡阳",
                "value": "430400"
            },
            {
                "text": "邵阳",
                "value": "430500"
            },
            {
                "text": "岳阳",
                "value": "430600"
            },
            {
                "text": "常德",
                "value": "430700"
            },
            {
                "text": "张家界",
                "value": "430800"
            },
            {
                "text": "益阳",
                "value": "430900"
            },
            {
                "text": "郴州",
                "value": "431000"
            },
            {
                "text": "永州",
                "value": "431100"
            },
            {
                "text": "怀化",
                "value": "431200"
            },
            {
                "text": "娄底",
                "value": "431300"
            },
            {
                "text": "湘西土家族苗族自治州",
                "value": "433100"
            }
        ]
    },
    {
        "text": "广东",
        "value": "440000",
        "children": [
            {
                "text": "广州",
                "value": "440100"
            },
            {
                "text": "韶关",
                "value": "440200"
            },
            {
                "text": "深圳",
                "value": "440300"
            },
            {
                "text": "珠海",
                "value": "440400"
            },
            {
                "text": "汕头",
                "value": "440500"
            },
            {
                "text": "佛山",
                "value": "440600"
            },
            {
                "text": "江门",
                "value": "440700"
            },
            {
                "text": "湛江",
                "value": "440800"
            },
            {
                "text": "茂名",
                "value": "440900"
            },
            {
                "text": "肇庆",
                "value": "441200"
            },
            {
                "text": "惠州",
                "value": "441300"
            },
            {
                "text": "梅州",
                "value": "441400"
            },
            {
                "text": "汕尾",
                "value": "441500"
            },
            {
                "text": "河源",
                "value": "441600"
            },
            {
                "text": "阳江",
                "value": "441700"
            },
            {
                "text": "清远",
                "value": "441800"
            },
            {
                "text": "东莞",
                "value": "441900"
            },
            {
                "text": "中山",
                "value": "442000"
            },
            {
                "text": "潮州",
                "value": "445100"
            },
            {
                "text": "揭阳",
                "value": "445200"
            },
            {
                "text": "云浮",
                "value": "445300"
            }
        ]
    },
    {
        "text": "广西",
        "value": "450000",
        "children": [
            {
                "text": "南宁",
                "value": "450100"
            },
            {
                "text": "柳州",
                "value": "450200"
            },
            {
                "text": "桂林",
                "value": "450300"
            },
            {
                "text": "梧州",
                "value": "450400"
            },
            {
                "text": "北海",
                "value": "450500"
            },
            {
                "text": "防城港",
                "value": "450600"
            },
            {
                "text": "钦州",
                "value": "450700"
            },
            {
                "text": "贵港",
                "value": "450800"
            },
            {
                "text": "玉林",
                "value": "450900"
            },
            {
                "text": "百色",
                "value": "451000"
            },
            {
                "text": "贺州",
                "value": "451100"
            },
            {
                "text": "河池",
                "value": "451200"
            },
            {
                "text": "来宾",
                "value": "451300"
            },
            {
                "text": "崇左",
                "value": "451400"
            }
        ]
    },
    {
        "text": "海南",
        "value": "460000",
        "children": [
            {
                "text": "海口",
                "value": "460100"
            },
            {
                "text": "三亚",
                "value": "460200"
            },
            {
                "text": "三沙",
                "value": "460300"
            },
            {
                "text": "儋州",
                "value": "460400"
            }
        ]
    },
    {
        "text": "重庆",
        "value": "500000",
        "children": [
            {
                "text": "重庆",
                "value": "500101"
            }
        ]
    },
    {
        "text": "四川",
        "value": "510000",
        "children": [
            {
                "text": "成都",
                "value": "510100"
            },
            {
                "text": "自贡",
                "value": "510300"
            },
            {
                "text": "攀枝花",
                "value": "510400"
            },
            {
                "text": "泸州",
                "value": "510500"
            },
            {
                "text": "德阳",
                "value": "510600"
            },
            {
                "text": "绵阳",
                "value": "510700"
            },
            {
                "text": "广元",
                "value": "510800"
            },
            {
                "text": "遂宁",
                "value": "510900"
            },
            {
                "text": "内江",
                "value": "511000"
            },
            {
                "text": "乐山",
                "value": "511100"
            },
            {
                "text": "南充",
                "value": "511300"
            },
            {
                "text": "眉山",
                "value": "511400"
            },
            {
                "text": "宜宾",
                "value": "511500"
            },
            {
                "text": "广安",
                "value": "511600"
            },
            {
                "text": "达州",
                "value": "511700"
            },
            {
                "text": "雅安",
                "value": "511800"
            },
            {
                "text": "巴中",
                "value": "511900"
            },
            {
                "text": "资阳",
                "value": "512000"
            },
            {
                "text": "阿坝藏族羌族自治州",
                "value": "513200"
            },
            {
                "text": "甘孜藏族自治州",
                "value": "513300"
            },
            {
                "text": "凉山彝族自治州",
                "value": "513400"
            }
        ]
    },
    {
        "text": "贵州",
        "value": "520000",
        "children": [
            {
                "text": "贵阳",
                "value": "520100"
            },
            {
                "text": "六盘水",
                "value": "520200"
            },
            {
                "text": "遵义",
                "value": "520300"
            },
            {
                "text": "安顺",
                "value": "520400"
            },
            {
                "text": "毕节",
                "value": "520500"
            },
            {
                "text": "铜仁",
                "value": "520600"
            },
            {
                "text": "黔西南布依族苗族自治州",
                "value": "522300"
            },
            {
                "text": "黔东南苗族侗族自治州",
                "value": "522600"
            },
            {
                "text": "黔南布依族苗族自治州",
                "value": "522700"
            }
        ]
    },
    {
        "text": "云南",
        "value": "530000",
        "children": [
            {
                "text": "昆明",
                "value": "530100"
            },
            {
                "text": "曲靖",
                "value": "530300"
            },
            {
                "text": "玉溪",
                "value": "530400"
            },
            {
                "text": "保山",
                "value": "530500"
            },
            {
                "text": "昭通",
                "value": "530600"
            },
            {
                "text": "丽江",
                "value": "530700"
            },
            {
                "text": "普洱",
                "value": "530800"
            },
            {
                "text": "临沧",
                "value": "530900"
            },
            {
                "text": "楚雄彝族自治州",
                "value": "532300"
            },
            {
                "text": "红河哈尼族彝族自治州",
                "value": "532500"
            },
            {
                "text": "文山壮族苗族自治州",
                "value": "532600"
            },
            {
                "text": "西双版纳傣族自治州",
                "value": "532800"
            },
            {
                "text": "大理白族自治州",
                "value": "532900"
            },
            {
                "text": "德宏傣族景颇族自治州",
                "value": "533100"
            },
            {
                "text": "怒江傈僳族自治州",
                "value": "533300"
            },
            {
                "text": "迪庆藏族自治州",
                "value": "533400"
            }
        ]
    },
    {
        "text": "西藏自治区",
        "value": "540000",
        "children": [
            {
                "text": "拉萨",
                "value": "540100"
            },
            {
                "text": "日喀则",
                "value": "540200"
            },
            {
                "text": "昌都",
                "value": "540300"
            },
            {
                "text": "林芝",
                "value": "540400"
            },
            {
                "text": "山南",
                "value": "540500"
            },
            {
                "text": "那曲",
                "value": "540600"
            },
            {
                "text": "阿里地区",
                "value": "542500"
            }
        ]
    },
    {
        "text": "陕西",
        "value": "610000",
        "children": [
            {
                "text": "西安",
                "value": "610100"
            },
            {
                "text": "铜川",
                "value": "610200"
            },
            {
                "text": "宝鸡",
                "value": "610300"
            },
            {
                "text": "咸阳",
                "value": "610400"
            },
            {
                "text": "渭南",
                "value": "610500"
            },
            {
                "text": "延安",
                "value": "610600"
            },
            {
                "text": "汉中",
                "value": "610700"
            },
            {
                "text": "榆林",
                "value": "610800"
            },
            {
                "text": "安康",
                "value": "610900"
            },
            {
                "text": "商洛",
                "value": "611000"
            }
        ]
    },
    {
        "text": "甘肃",
        "value": "620000",
        "children": [
            {
                "text": "兰州",
                "value": "620100"
            },
            {
                "text": "嘉峪关",
                "value": "620200"
            },
            {
                "text": "金昌",
                "value": "620300"
            },
            {
                "text": "白银",
                "value": "620400"
            },
            {
                "text": "天水",
                "value": "620500"
            },
            {
                "text": "武威",
                "value": "620600"
            },
            {
                "text": "张掖",
                "value": "620700"
            },
            {
                "text": "平凉",
                "value": "620800"
            },
            {
                "text": "酒泉",
                "value": "620900"
            },
            {
                "text": "庆阳",
                "value": "621000"
            },
            {
                "text": "定西",
                "value": "621100"
            },
            {
                "text": "陇南",
                "value": "621200"
            },
            {
                "text": "临夏回族自治州",
                "value": "622900"
            },
            {
                "text": "甘南藏族自治州",
                "value": "623000"
            }
        ]
    },
    {
        "text": "青海",
        "value": "630000",
        "children": [
            {
                "text": "西宁",
                "value": "630100"
            },
            {
                "text": "海东",
                "value": "630200"
            },
            {
                "text": "海北藏族自治州",
                "value": "632200"
            },
            {
                "text": "黄南藏族自治州",
                "value": "632300"
            },
            {
                "text": "海南藏族自治州",
                "value": "632500"
            },
            {
                "text": "果洛藏族自治州",
                "value": "632600"
            },
            {
                "text": "玉树藏族自治州",
                "value": "632700"
            },
            {
                "text": "海西蒙古族藏族自治州",
                "value": "632800"
            }
        ]
    },
    {
        "text": "宁夏回族自治区",
        "value": "640000",
        "children": [
            {
                "text": "银川",
                "value": "640100"
            },
            {
                "text": "石嘴山",
                "value": "640200"
            },
            {
                "text": "吴忠",
                "value": "640300"
            },
            {
                "text": "固原",
                "value": "640400"
            },
            {
                "text": "中卫",
                "value": "640500"
            }
        ]
    },
    {
        "text": "新疆维吾尔自治区",
        "value": "650000",
        "children": [
            {
                "text": "乌鲁木齐",
                "value": "650100"
            },
            {
                "text": "克拉玛依",
                "value": "650200"
            },
            {
                "text": "吐鲁番",
                "value": "650400"
            },
            {
                "text": "哈密",
                "value": "650500"
            },
            {
                "text": "昌吉回族自治州",
                "value": "652300"
            },
            {
                "text": "博尔塔拉蒙古自治州",
                "value": "652700"
            },
            {
                "text": "巴音郭楞蒙古自治州",
                "value": "652800"
            },
            {
                "text": "阿克苏地区",
                "value": "652900"
            },
            {
                "text": "克孜勒苏柯尔克孜自治州",
                "value": "653000"
            },
            {
                "text": "喀什地区",
                "value": "653100"
            },
            {
                "text": "和田地区",
                "value": "653200"
            },
            {
                "text": "伊犁哈萨克自治州",
                "value": "654000"
            },
            {
                "text": "塔城地区",
                "value": "654200"
            },
            {
                "text": "阿勒泰地区",
                "value": "654300"
            }
        ]
    },
    {
        "text": "台湾",
        "value": "710000",
        "children": [
            {
                "text": "新北",
                "value": ""
            },
            {
                "text": "高雄",
                "value": ""
            },
            {
                "text": "台中",
                "value": ""
            },
            {
                "text": "台北",
                "value": ""
            },
            {
                "text": "桃园",
                "value": ""
            },
            {
                "text": "台南",
                "value": ""
            },
            {
                "text": "基隆",
                "value": ""
            },
            {
                "text": "新竹",
                "value": ""
            },
            {
                "text": "嘉义",
                "value": ""
            },
            {
                "text": "新竹县",
                "value": ""
            },
            {
                "text": "苗栗县",
                "value": ""
            },
            {
                "text": "彰化县",
                "value": ""
            },
            {
                "text": "南投县",
                "value": ""
            },
            {
                "text": "云林县",
                "value": ""
            },
            {
                "text": "嘉义县",
                "value": ""
            },
            {
                "text": "屏东县",
                "value": ""
            },
            {
                "text": "宜兰县",
                "value": ""
            },
            {
                "text": "花莲县",
                "value": ""
            },
            {
                "text": "台东县",
                "value": ""
            },
            {
                "text": "澎湖县",
                "value": ""
            }
        ]
    }
]
export default {
    provideData
}


//////////////////
// WEBPACK FOOTER
// ./config/provice.js
// module id = fO00
// module chunks = 16